const app = require('app')

module.exports = ({ el }) => {
  el.on('click', (e) => {
    e.preventDefault()
    e.stopPropagation()
    const url = e.currentTarget.href
    const xhr = new window.XMLHttpRequest()
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 2) {
        if (xhr.status === 200) {
          return window.open(url)
        } else {
          app.events.commands.execute('modal:attachments-pending-modal:show')
        }
      }
    }
    xhr.open('GET', url)
    xhr.send()
  })
}
